<div class="create-journey-container" *ngIf="!isEditMode">
  <div class="journey-header">
    <div class="journey-title">Define Customer Journey</div>
    <div class="journey-description">
      Welcome to your Customer Journey setup! Start by assigning key projects to each stage of the journey. This view
      helps you visualize customer experience over time.
    </div>
  </div>
  <ng-container *ngTemplateOutlet="createJourney"></ng-container>

  <div class="journey-content-card" *ngIf="journeyList.length == 0">
    <div class="journey-empty-state">
      <div class="empty-state-content">
        <div class="empty-state-title">No Journey Found</div>
        <div class="empty-state-description">Add your first journey  to get started.</div>
        <button class="add-first-stage-btn" [disabled]="readOnlyMode" (click)="addJourneyStage()">
          Add first Journey
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Add Language Side Panel -->
<div class="journey-side-panel" *ngIf="isEditMode">
  <div class="side-panel-overlay" (click)="closeQuestionModal()"></div>
  <div class="side-panel-container">
    <div class="side-panel-header">
      <div class="header-label" *ngIf="!readOnlyMode">Update Journey</div>
      <div class="header-label" *ngIf="readOnlyMode">View Journey Details</div>
      <div class="header-actions">
        <button class="close-button" (click)="closeQuestionModal()">
          <img src="./assets/images/close.svg">
        </button>
      </div>
    </div>

    <div class="side-panel-content">
      <ng-container *ngTemplateOutlet="createJourney"></ng-container>
    </div>
    <div class="side-panel-footer" *ngIf="!readOnlyMode">
      <!-- <button class="btn-cancel" (click)="closeQuestionModal()">Cancel</button>
        <button class="btn-save" id="saveInteractionButton" (click)="saveInteraction()" [disabled]="!isDirty">
            {{(isEditMode)?'Update':'Save'}}
        </button> -->
      <div class="journey-actions">
        <button class="add-stage-btn" [disabled]="!isJourneyListValid || journeyList.length >= 10" (click)="addJourneyStage()">
          + Add a Journey
        </button>
        <button class="proceed-btn" [disabled]="!isUserUniqueFieldValid || !isJourneyListValid || !isDirty || !isMinimumResponsesValid" (click)="proceedToJourney()">
          Proceed to Journey
        </button>
      </div>
    </div>
  </div>
</div>



<ng-template #createJourney>

  <div class="journey-content-card  journey-user-field-details" *ngIf="journeyList.length > 0" [ngClass]="{'edit-mode': isEditMode}" >
    <div class="journey-user-field-details-item journey-user-field-details-item--select">
      <div class="stage-label"> User Unique Field <span *ngIf="readOnlyMode">:</span></div>
      <div class="select-input-wrapper">
        <select class="form-select" [disabled]="readOnlyMode" [(ngModel)]="userUniqueField"
          (ngModelChange)="validateUserUniqueField()"
          (blur)="validateUserUniqueField()"
          [class.error]="userUniqueFieldError">
          <option value="">Select Field</option>
          <option *ngFor="let field of userFieldList" [value]="field.field_id">{{field.text}}</option>
        </select>
        <div class="error-message error-message--below" *ngIf="!userUniqueField ||  userUniqueField ==  ''"> User unique field is required.</div>
      </div>
    </div>
    <div class="journey-user-field-details-item journey-user-field-details-item--number">
      <div class="stage-label"> Minmum Number Of Responses <span *ngIf="readOnlyMode">:</span></div>
      <div class="number-input-wrapper">
        <input type="number" [disabled]="readOnlyMode" [(ngModel)]="minimumNumberOfResponses" min="2" step="1"
          (keypress)="validateNumber($event)"
          (keyup)="validateMinimumResponsesField()"
          (blur)="validateMinimumResponsesField()"
          (ngModelChange)="validateMinimumResponsesField()"
          [class.error]="minimumNumberOfResponsesError"
          class="form-control">
        <div class="error-message error-message--below" *ngIf="minimumNumberOfResponsesError">{{ minimumNumberOfResponsesError }}</div>
      </div>
    </div>
  </div>

  <div class="journey-content-card" [ngClass]="{'edit-mode': isEditMode}" *ngIf="journeyList.length > 0">
    <div class="journey-stages">
      <div class="journey-stage" *ngFor="let journeyObject of journeyList; let i = index">
        <div class="stage-number">{{ i + 1 }}</div>
        <div class="stage-details-inputs">
          <div class="stage-details-item">
            <div class="stage-input-label">
              Journey Name <span *ngIf="readOnlyMode">:</span>
            </div>
            <div class="stage-name-input">
              <input type="text" [disabled]="readOnlyMode" [value]="journeyObject.name" [class.fields_error]="journeyObject.error?.name_error" minlength="3" maxlength="50" (input)="updateStageName(i, $event)" placeholder="Enter journey name">
              <div class="error-message" *ngIf="journeyObject.error?.name_error">Name is already exists</div>
            </div>
          </div>
          <div class="stage-details-item">
            <div class="stage-input-label">
              Description <span *ngIf="readOnlyMode">:</span>
            </div>
            <div class="stage-name-input">
              <textarea type="text" [disabled]="readOnlyMode" [value]="journeyObject.description"  [class.fields_error]="journeyObject.error?.name_error" minlength="3" maxlength="50" (input)="updateStageDescription(i, $event)" [placeholder]="(readOnlyMode && !journeyObject.description)?'NA':'Provide a description for journey'"></textarea>
              <div class="error-message" *ngIf="journeyObject.error?.description_error">Description is required</div>
            </div>
          </div>
          <div class="stage-details-item">
            <div class="stage-input-label">
              Stages/Projects Mapping <span *ngIf="readOnlyMode">:</span>
            </div>
            <div class="project-assignment">
              <div class="multi-select-dropdown">
                <button class="dropdown-button" [disabled]="readOnlyMode" [class.fields_error]="journeyObject.error?.fields_error" (click)="toggleDropdown(i)" [class.open]="journeyObject.isOpen">
                  <div class="selected-projects" *ngIf="journeyObject.field_values.length > 0">
                    <span class="project-placeholder" *ngIf="!journeyObject.field_values  || journeyObject.field_values.length <= 0">
                      Select field
                    </span>
                    <ng-container *ngIf="journeyObject.field_values && journeyObject.field_values.length > 0">
                      <span class="project-tag" *ngFor="let field of journeyObject.fields; let j = index">
                        {{ selectedFieldMapping[field.value] }}
                        <button class="remove-project" *ngIf="!readOnlyMode" (click)="removeProject(i, j, $event)">×</button>
                      </span>
                    </ng-container>
    
                  </div>
                  <span class="placeholder" *ngIf="journeyObject.field_values.length === 0">Select field</span>
                  <span class="dropdown-arrow" *ngIf="!readOnlyMode">
                    <img src="./assets/images/menu-down-dark.svg" alt="menu-down-dark">
                  </span>
                </button>
                <div class="dropdown-options" *ngIf="journeyObject.isOpen">
                  <div class="option" *ngFor="let option of dropdownData" (click)="selectField(i, option)"
                    [class.selected]="journeyObject.field_values.includes(option.value)">
                    <!-- <img class="default-img" *ngIf="!stage.projects.includes(option.id)"
                      src="./assets/images/checkbox-blank-outline.svg" />
                    <img class="active-img" *ngIf="stage.field_values.includes(option.id)"
                      src="./assets/images/checkbox-marked.svg" />  -->
    
                      <svg class="checkbox-icon-img">
                        <use [attr.xlink:href]="(journeyObject.field_values.includes(option.value))? './assets/images/icons.svg#checkbox-marked' : './assets/images/icons.svg#checkbox-blank-outline'"></use>
                      </svg>
                    <!-- <span class="checkbox" [class.checked]="stage.projects.includes(option.id)">✓</span> -->
                    {{ selectedFieldMapping[option.value] }}
                  </div>
                  <!-- <div class="add-custom-option">
                    <input type="text" 
                           placeholder="Add custom project..." 
                           (keyup.enter)="addCustomProject(i, $event)"
                           (blur)="addCustomProject(i, $event)">
                  </div> -->
                </div>
              </div>
              <div class="error-message" *ngIf="journeyObject.error?.fields_error">Fields are already exists</div>
            </div>
          </div>
        </div>
        <button class="delete-stage" *ngIf="!readOnlyMode" [disabled]="journeyList.length == 1 && journeyObject.name == ''  && journeyObject.field_values.length == 0" (click)="confirmDeleteJourney(i)">
          <img src="./assets/images/trash-can-outline.svg">
        </button>
      </div>
    </div>

    <div class="journey-actions" *ngIf="!isEditMode && !readOnlyMode">
      <button class="add-stage-btn" [disabled]="!isJourneyListValid || journeyList.length >= 10" (click)="addJourneyStage()">
        + Add a Journey
      </button>
      <button class="proceed-btn" [disabled]="!isUserUniqueFieldValid || !isJourneyListValid || !isDirty || !isMinimumResponsesValid" (click)="proceedToJourney()">
        Proceed to Journey
      </button>
    </div>
  </div>
</ng-template>